import { render, staticRenderFns } from "./DataCollectionMain.vue?vue&type=template&id=ea365528&scoped=true&"
import script from "./DataCollectionMain.vue?vue&type=script&lang=js&"
export * from "./DataCollectionMain.vue?vue&type=script&lang=js&"
import style0 from "./DataCollectionMain.vue?vue&type=style&index=0&id=ea365528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea365528",
  null
  
)

export default component.exports